'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserProfile = fetchUserProfile;
exports.fetchPublicAvailabilityInfo = fetchPublicAvailabilityInfo;
exports.fetchCompanyName = fetchCompanyName;
exports.createMeeting = createMeeting;

var _endpoints = require('MeetingsLib/constants/endpoints');

function fetchUserProfile(httpClient, slug, includeInactiveLink) {
  return httpClient.get(_endpoints.PUBLIC_BOOK_ENDPOINT + '/' + slug + '/user?includeInactiveLink=' + includeInactiveLink, {
    withCredentials: false
  });
}

function fetchPublicAvailabilityInfo(httpClient, slug, queryParams) {
  return httpClient.get(_endpoints.PUBLIC_BOOK_ENDPOINT + '/' + slug + '/book-info', {
    withCredentials: false,
    query: queryParams,
    timeout: 12000
  });
}

function fetchCompanyName(httpClient, slug) {
  return httpClient.get(_endpoints.LINK_ENDPOINT + '/' + slug + '/company', {
    withCredentials: false
  });
}

function createMeeting(httpClient, slug, queryParams, data) {
  return httpClient.post(_endpoints.PUBLIC_BOOK_ENDPOINT + '/' + slug, {
    withCredentials: false,
    query: queryParams,
    timeout: 30000,
    data: data
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/api/bookingAPI.js
// module id = 321
// module chunks = 0